import { useState } from 'react';
import { LogOut, HelpCircle } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { Dropdown } from '../Dropdown';
import { AboutModal } from '../AboutModal';

export const Header = () => {
  const { user, logout } = useAuth();
  const [isAboutModalOpen, setIsAboutModalOpen] = useState(false);

  // Get user initials for avatar
  const getInitials = () => {
    if (!user) return 'U';

    const displayName = user.displayName || '';
    const email = user.email || '';

    // Try to get initials from display name first
    if (displayName) {
      const parts = displayName.split(' ');
      if (parts.length >= 2) {
        return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
      }
      return displayName.substring(0, 2).toUpperCase();
    }

    // Fallback to email
    if (email) {
      return email.substring(0, 2).toUpperCase();
    }

    return 'U';
  };

  const handleLogout = async () => {
    await logout();
  };

  return (
    <header className="flex items-center justify-between border-b border-gray-200 pl-4">
      <div className="flex items-center space-x-4">
        {/* This space is reserved for breadcrumbs or page title if needed */}
      </div>

      <div className="flex items-center space-x-4">
        <Dropdown
          trigger={
            <>
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-500 text-sm font-medium text-white">
                {getInitials()}
              </div>
              <span className="text-sm font-medium">{user?.displayName || user?.email || 'User'}</span>
            </>
          }
          triggerClassName="flex items-center space-x-2 rounded-lg p-2 transition-colors hover:bg-gray-100"
        >
          <div className="border-b border-gray-100 px-4 py-2">
            <p className="text-sm font-medium text-gray-900">{user?.displayName || 'User'}</p>
            <p className="text-xs text-gray-500">{user?.email || ''}</p>
          </div>

          <div className="py-1">
            <button
              type="button"
              onClick={() => setIsAboutModalOpen(true)}
              className="flex w-full items-center px-4 py-2 text-sm text-gray-700 transition-colors hover:bg-gray-50"
            >
              <HelpCircle className="mr-3 h-4 w-4" />
              About
            </button>
          </div>

          <div className="border-t border-gray-100 py-1">
            <button
              className="flex w-full items-center px-4 py-2 text-sm text-red-600 transition-colors hover:bg-red-50"
              type="button"
              onClick={handleLogout}
            >
              <LogOut className="mr-3 h-4 w-4" />
              Logout
            </button>
          </div>
        </Dropdown>
      </div>

      {/* About Modal */}
      <AboutModal isOpen={isAboutModalOpen} onClose={() => setIsAboutModalOpen(false)} />
    </header>
  );
};
